export default __webpack_public_path__ + "static/media/IMG_4472.00adcf3d.jpg";